import { Box } from "@mui/material"
import type { DateRange } from "@mui/x-date-pickers-pro"
import type { Dayjs } from "dayjs"
import { dayjsUTC } from "../../utils/dates"
import {
  PHCDateRangePicker,
  RelativeDateRangeChoiceId,
} from "../Shared/PHCDateRangePicker"
import { ChartContainer } from "./ChartContainer"
import { getDates } from "../../utils/dates"

export const ChartWithFilters = ({
  title,
  tooltipContent,
  dataSourcePill,
  filters: { tabs, dateRangePicker, dateRange, onDateRangeChange },
  children,
}: {
  title: string
  tooltipContent: string | React.ReactNode
  dataSourcePill?: React.ReactNode
  children: React.ReactNode
  filters: {
    dateRangePicker?: React.ReactNode
    dateRange?: DateRange<Dayjs>
    onDateRangeChange?: (dateRange: DateRange<Dayjs>) => void
    tabs?: React.ReactNode
  }
}) => {
  const defaultDateRangePicker = (
    <PHCDateRangePicker
      initialValue={dateRange}
      onChange={dates => {
        onDateRangeChange?.(getDates(dates))
      }}
      maxDate={dayjsUTC()}
      showTime={false}
      showRelativeDateRanges={true}
      visibleRelativeDateRangeChoices={[
        RelativeDateRangeChoiceId.ThirtyDays,
        RelativeDateRangeChoiceId.ThreeMonths,
        RelativeDateRangeChoiceId.TwelveMonths,
      ]}
    />
  )

  const displayedDateRangePicker = dateRangePicker ?? defaultDateRangePicker
  const filtersDisplay = (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Box>{tabs}</Box>
      <Box
        sx={{
          width: 350,
        }}
      >
        {displayedDateRangePicker}
      </Box>
    </Box>
  )

  return (
    <ChartContainer
      title={title}
      tooltipContent={tooltipContent}
      dataSourcePill={dataSourcePill}
      slots={{
        filters: filtersDisplay,
      }}
    >
      {children}
    </ChartContainer>
  )
}
